import { render, staticRenderFns } from "./AlertSnackbar.vue?vue&type=template&id=243f3dfa"
import script from "./AlertSnackbar.vue?vue&type=script&lang=js"
export * from "./AlertSnackbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_068c914d031cd2060dd4a326836f4c99/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports